'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ContactInformation = require('../ContactInformation');

var _ContactInformation2 = _interopRequireDefault(_ContactInformation);

var _customSectionSharedFunctions = require('./customSectionSharedFunctions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Entity = function (_Component) {
  _inherits(Entity, _Component);

  function Entity() {
    _classCallCheck(this, Entity);

    return _possibleConstructorReturn(this, (Entity.__proto__ || Object.getPrototypeOf(Entity)).apply(this, arguments));
  }

  _createClass(Entity, [{
    key: 'renderPerson',
    value: function renderPerson(personData, title) {
      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'span',
          { className: 'bold' },
          personData.names && personData.names.length > 0 ? personData.names[0].fullName : null
        ),
        _react2.default.createElement(
          'span',
          { className: 'capitalize' },
          title ? "(" + title + ") " : null
        ),
        personData.names && personData.names.length > 1 ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'span',
            null,
            'Alternate Name(s): '
          ),
          ' ',
          (0, _customSectionSharedFunctions.renderArray)(personData.names.slice(1).map(function (name) {
            return name.fullName;
          }))
        ) : null
      );
    }
  }, {
    key: 'renderIdentifier',
    value: function renderIdentifier(identifier, index) {
      return _react2.default.createElement(
        'span',
        { key: index },
        identifier && identifier.identifierNumber && identifier.identifierType ? _react2.default.createElement(
          'span',
          null,
          identifier.identifierType + ": " + identifier.identifierNumber
        ) : null
      );
    }
  }, {
    key: 'renderOrganization',
    value: function renderOrganization(organization) {
      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'span',
          null,
          'Organization: '
        ),
        organization.names ? _react2.default.createElement(
          'span',
          null,
          (0, _customSectionSharedFunctions.renderArray)(organization.names.map(function (name) {
            return name.name;
          })),
          ' '
        ) : null,
        _react2.default.createElement(
          'div',
          null,
          organization && organization.orgIdentifiers && organization.orgIdentifiers.length > 0 ? organization.orgIdentifiers.map(this.renderIdentifier) : null,
          organization && organization.standardIndustryClassCode ? _react2.default.createElement(
            'div',
            null,
            "Standard Industry Class Code: " + organization.standardIndustryClassCode
          ) : null
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'div',
          null,
          this.props.person ? this.renderPerson(this.props.person, this.props.title) : null,
          _react2.default.createElement(
            'div',
            null,
            this.props.code ? _react2.default.createElement(
              'div',
              null,
              "Code: " + this.props.code
            ) : null,
            this.props.identifiers && this.props.identifiers.length > 0 ? _react2.default.createElement(
              'div',
              null,
              this.props.identifiers.map(this.renderIdentifier)
            ) : null,
            this.props.organization ? this.renderOrganization(this.props.organization) : null
          )
        ),
        _react2.default.createElement(_ContactInformation2.default, { phoneList: this.props.phones, addressList: this.props.addresses })
      );
    }
  }]);

  return Entity;
}(_react.Component);

Entity.propTypes = {
  identifiers: _propTypes2.default.array,
  code: _propTypes2.default.string,
  addresses: _propTypes2.default.array,
  phones: _propTypes2.default.array,
  person: _propTypes2.default.object,
  title: _propTypes2.default.string,
  organization: _propTypes2.default.object
};

exports.default = Entity;


//////////////////
// WEBPACK FOOTER
// ./node_modules/updox-care-record-viewer/lib/reactComponents/customSections/Entity.js
// module id = 476
// module chunks = 0